import { Heading, ImageThumbnail, Input, Radio, Text } from '~src/components/display';
import { FileUploadButton } from '~src/components/features/file';
import { useLocalization } from '~src/hooks';

import { SiteVisitNote } from './SiteVisitNote';
import { QuestionSectionProps } from './types';
import { SiteVisitSections } from './utilities/siteVisitConstants';

import { displayColumn } from '~src/style/shared.module.css';

import { imageUpload, questionRows, siteVisitSectionHeader } from './SiteVisit.module.css';

export const QuestionSectionElectricitySolar = ({
  answerMap,
  imageList,
  isLoading,
  updateAnswer,
  uploadImages,
  isUploadingImages,
}: QuestionSectionProps) => {
  const translate = useLocalization();

  const cableLength = Number(answerMap?.distanceToSolar?.answer ?? '0');
  const extraCableRequired = Number.isNaN(cableLength) || cableLength > 10;

  return (
    <div className={displayColumn}>
      <Heading className={siteVisitSectionHeader} level={2}>
        4. {translate.SITE_VISIT_SECTION_SOLAR_ELECTRICITY}
      </Heading>

      <div className={questionRows}>
        <Text>{translate.SITE_VISIT_QUESTION_SOLAR_ELECTRICITY_RELAY}:</Text>
        <Radio.Group
          onChange={event => {
            updateAnswer('electricRelayAutoSafetyAndExtra', event?.target?.value);
          }}
          value={answerMap?.electricRelayAutoSafetyAndExtra?.answer}
          disabled={isLoading}
        >
          <Radio.Button value='existingRelay'>{translate.SITE_VISIT_ANSWER_EXISTING_PANEL}</Radio.Button>
          <Radio.Button value='upgradeRelay'>{translate.SITE_VISIT_ANSWER_UPGRADE_PANEL}</Radio.Button>
        </Radio.Group>
        <SiteVisitNote
          display={answerMap?.electricRelayAutoSafetyAndExtra?.answer === 'upgradeRelay'}
          text={translate.SITE_VISIT_DISCLAIMER_UPGRADE_RELAY}
          type='expense'
        />

        <Text>{translate.SITE_VISIT_QUESTION_SOLAR_ELECTRICITY_WIRE_LENGTH}</Text>
        <Input
          onChange={event => {
            updateAnswer('distanceToSolar', event?.target?.value);
          }}
          value={answerMap?.distanceToSolar?.answer}
        />
        <SiteVisitNote
          display={extraCableRequired}
          text={translate.SITE_VISIT_DISCLAIMER_EXTRA_CABLE_SOLAR}
          type='expense'
        />

        <Text>{translate.SITE_VISIT_QUESTION_SOLAR_ELECTRICITY_WIRE_PLACEMENT}:</Text>
        <Radio.Group
          onChange={event => {
            updateAnswer('wiringInCeilingForSolar', event?.target?.value);
          }}
          value={answerMap?.wiringInCeilingForSolar?.answer}
          disabled={isLoading}
        >
          <Radio.Button value='true'>{translate.YES}</Radio.Button>
          <Radio.Button value='false'>{translate.NO}</Radio.Button>
        </Radio.Group>

        <Text>{translate.NOTES}</Text>
        <Input.TextArea
          onBlur={event => {
            updateAnswer('electricitySolarNotes', event?.target?.value);
          }}
          defaultValue={answerMap?.electricitySolarNotes?.answer}
        />

        <Text>{translate.IMAGES}</Text>
        <div className={imageUpload}>
          {imageList?.map(image => <ImageThumbnail key={image.url} image={image} />)}

          <FileUploadButton
            isLoading={isUploadingImages}
            buttonText={translate.UPLOAD}
            multiple
            onUpload={(images: File[]) => uploadImages?.(images, SiteVisitSections.electricity)}
            type='thumbnail'
          />
        </div>
      </div>
    </div>
  );
};
